<template>
  <div v-if="totalSlides > 1" class="custom-pagination-dots">
    <v-btn
      v-for="(_, index) in totalSlides"
      :key="index"
      :class="{ 'dot-active': currentSlide === index }"
      @click="handleDotClick(index)"
      class="custom-dot"
      variant="text"
    >
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "PaginationDots",
  props: {
    totalSlides: {
      type: Number,
      required: true
    },
    currentSlide: {
      type: Number,
      required: true
    }
  },
  emits: ['dot-click'],
  methods: {
    handleDotClick(index) {
      this.$emit('dot-click', index);
    }
  }
}
</script>

<style scoped>
.custom-pagination-dots {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  bottom: 20px;
  left: 20px;
  gap: 30px;
}

.custom-dot {
  width: 15px !important;
  height: 15px !important;
  border-radius: 50%;
  min-width: 8px;
  min-height: 8px;
  box-shadow: none;
  padding: 0;
  margin: 0;
  background-color: #e0e0e0;
}

.custom-dot.dot-active {
  background-color: #6b6b6b7e;
}

@media (max-width: 768px) {
  .custom-pagination-dots {
    justify-content: center;
    left: 50%;
    transform: translateX(-50%);
    bottom: 10px;
    gap: 20px;
  }
}
</style> 